var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from 'react';
import * as R from 'ramda';
import { Tree } from 'primereact/tree';
//
var obj2Menu = function (_a) {
    var id = _a.id, header = _a.header, frontOptions = _a.frontOptions;
    return ({
        label: header || R.prop('header', frontOptions),
        key: id,
        data: { id: id },
        children: []
    });
};
var isGroup = function (_a) {
    var kind = _a.kind;
    return R.contains(kind, ['group', 'table', 'tabs', 'tab']);
};
var mapMenu = function (def) {
    return !def.elements ? [] : R.pipe(R.filter(function (el) { return !el.hidden && !R.path(['frontOptions', 'isModal'], el); }), R.map(function (el) { return isGroup(el) && (el.header || R.path(['frontOptions', 'header'], el))
        ? (__assign(__assign({}, obj2Menu(el)), { children: mapMenu(el) }))
        : (Array.isArray(el.elements) ? mapMenu(el) : []); }), R.flatten)(def.elements);
};
var TreeListContainer = /** @class */ (function (_super) {
    __extends(TreeListContainer, _super);
    function TreeListContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // private currentEl: Element;
    // private animationTimer;
    TreeListContainer.prototype.render = function () {
        var menu = mapMenu(this.props.def);
        return !(Array.isArray(menu) && menu.length > 0) ? (null) : React.createElement("div", { className: "p-col-fixed" },
            React.createElement(Tree, { style: { borderWidth: '0px', width: '100%' }, selectionMode: "single", value: menu, key: this.props.def.id + "-tree" }));
    };
    return TreeListContainer;
}(PureComponent));
export { TreeListContainer };
//# sourceMappingURL=TreeList.js.map